import { useState, useCallback } from 'react';
export type TabValue = 'ALL' | 'REQUEST' | 'CHAT';

interface Props {
  callback?: () => void;
}

const useViewerTab = ({
  callback
}: Props): [TabValue, (event: any, value: TabValue) => void] => {
  const [tab, setTab] = useState<TabValue>('ALL');

  const onChangeTab = useCallback(
    (e: any, value: TabValue) => {
      setTab(value);

      callback && callback();
    },
    [callback]
  );

  return [tab, onChangeTab];
};

export default useViewerTab;
